import { Col, Form, Popover, Row, Switch, notification } from "antd";
import { PRIVILLEGED_ROLES, ROLES } from "../../base/constant";
import React, { Fragment, useEffect, useState } from "react";

import { AntInput } from "../../shared/widges/antinput";
import { Cookie } from "../../base/utils";
import { CoreServices } from "../../base/service/apiServices";
import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import Loader from "../../shared/widges/Loader/loader";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import Lottie from "lottie-react";
import ShortCutKeys from "../../shortcutkeyFunction/shortCutKeysFunction";
import { shortcutKeyActions } from "../../store/slices/shortcutkeys_slice/shortcutkeys_slice";
import store from "../../base/store/store";
import styles from "./shortcutkeys.module.scss";
import { useDispatcher } from "../../custom_hooks/use_app_dispatch";
import { useSelector } from "react-redux";

function ShortcutKeys() {
  const [editCommand, setEditCommand] = useState<boolean>(false);
  const [keyData, setKeyData] = useState<any>([]);
  const [defaultKeyData, setDefaultKeyData] = useState<any>([]);
  const [keyId, setKeyId] = useState<any>("");
  const [defaultKeyId, setDefaultKeyId] = useState<any>("");
  const [customKeys, setCustomKeys] = useState<any>({
    key1: "",
    key2: "",
    key3: "",
  });
  const [validate, setValidate] = useState<boolean>(false);
  const [editId, setEditId] = useState<any>("");
  const [datas, setDatas] = useState<boolean>(false);
  const [loader, setLoader] = useState<any>([]);
  const [form] = Form.useForm();
  const dispatch: any = useDispatcher();
  const shortcutKeysSlice = useSelector((state: any) => state.shortcutKeys);
  // const token: any = Cookie.get();
  const roleId = GetItemFromStorage(LocalStorage.ROLE_ID);
  const productid = GetItemFromStorage(LocalStorage.PRODUCT_ID)
  
  useEffect(() => {
    getInitialValue();
    getDefaultInitialVal();
  }, []);

  const getInitialValue = () => {
    CoreServices.get(`/get_shortcut_keys`).then((res: any) => {
      if (res && res.data.statusCode === 200 && res.data.result?.length > 0) {
        const parsedData = JSON.parse(res.data.result[0].keyValues)
          const filteredData = parsedData?.filter((item: any) => {
          const data = item?.function?.toLowerCase();
          const filterData = ['call', 'prompt library', 'create prompt library']
          if (data === 'callback') {
            return true;
          }
          return !filterData?.some((keyword : any) => data?.includes(keyword));
        });
        if(productid == 15){
          setKeyData(filteredData)
        }else {
          setKeyData(parsedData);
        }
        setKeyId(res.data.result[0].keyId);
      } 
      else if(res && res.data.statusCode === 200 && res?.data?.result?.length === 0){
        CoreServices.post({}, `/insert_shortcut_keys`).then((res: any) => {  
          getInitialValue()
        })
      }
    }).catch((error: any)=> {
      console.log(error);
    });
  };

  const getDefaultInitialVal = () => {
    CoreServices.get(`/get_global_shortcut_keys`).then((res: any) => {
      if (res && res.data.statusCode === 200 && res?.data?.result?.length > 0) {
        const parsedData = JSON.parse(res.data.result[0].keyValues)
        const filteredData = parsedData?.filter((item: any) => !item?.function?.toLowerCase().includes('call'));
        if(productid == 15){
          setDefaultKeyData(filteredData)
        }else{
          setDefaultKeyData(parsedData);
        }
        setDefaultKeyId(res.data.result[0].keyId);
        setLoader(JSON.parse(res.data.result[0].keyValues));
      } else if (res && res.data.statusCode === 200 && res.data.message === "No data found") {
        CoreServices.post({}, `/insert_global_shortcut_keys`).then((res: any) => {
          getDefaultInitialVal();
        })
      }
    }).catch((error: any) => {
      console.log(error);
    });
  };

  const setSwitchAction = (e: any, data: any) => {
    try {
      setKeyData((prevKeys: any) =>
        prevKeys?.map((item: any) =>
          item?.uuid === data?.uuid ? { ...item, status: data?.status === 1 ? 0 : 1 } : item
        )
      );
      let body = {
        uuid: data.uuid,
        status: data.status,
        keyId: keyId,
      };

      CoreServices.put(body, `/update_status_shortcutkeys`).then(async (res: any) => {
        if (res && res.data.statusCode === 200) {
          getInitialValue();
          notification.info({
            message: `${data.function} Status Updated Successfully `,
            placement: "topRight",
            className: "toastNotification success",
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
            </svg>,
            closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
            </svg>,
            duration: 3,
            top: 70,
          });
          setDatas(true);
          dispatch(
            shortcutKeyActions.updateValue({
              isUpdate: !shortcutKeysSlice.isUpdate,
            })
          );
        }
      });
    } catch (error) {
      console.log(error)
      setKeyData((prevKeys: any) =>
        prevKeys?.map((item: any) =>
          item?.uuid === data?.uuid ? { ...item, status: data?.status } : item
        )
      );
    }

  };

  const setDefaultSwitchAction = (e: any, data: any) => {
    try {
      defaultKeyData((prevKeys: any) =>
        prevKeys.map((item: any) =>
          item?.uuid === data?.uuid ? { ...item, status: item?.status === 1 ? 0 : 1 } : item
        )
      );
      let body = {
        uuid: data.uuid,
        status: data.status,
        keyId: defaultKeyId,
      };
      CoreServices.put(body, `/update_status_shortcutkeys`).then(async (res: any) => {
        if (res && res.data.statusCode === 200) {
          getDefaultInitialVal();
          notification.info({
            message: `${data.function} Status Updated Successfully `,
            placement: "topRight",
            className: "toastNotification success",
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
            </svg>,
            closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
            </svg>,
            duration: 3,
            top: 70,
          });
          dispatch(
            shortcutKeyActions.updateValue({
              isUpdate: !shortcutKeysSlice.isUpdate,
            })
          );
        }
      });
    } catch (error) {
      console.log(error)
      defaultKeyData((prevKeys: any) =>
        prevKeys.map((item: any) =>
          item.uuid === data.uuid ? { ...item, status: data.status } : item
        )
      );
    }

  };

  const setOptions1 = (data: any) => {
    setEditCommand(false);
    setEditId(data.uuid);
    setCustomKeys(
      {
        key1: "",
        key2: "",
        key3: "",
      }
    )
    setTimeout(() => {
      setEditCommand(true);
    }, 20);
  };

  const setOptions2 = (data: any) => {
    let body: any = {
      uuid: data.uuid,
      keyId: keyId,
    };
    CoreServices.put(body, `/reset_global_shortcut_by_uuid`).then((res: any) => {
      if (res && res.data.statusCode === 200) {
        getInitialValue();
        notification.info({
          message: `${data.function} Restored Successfully `,
          placement: "topRight",
          className: "toastNotification success",
          icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000"/>
</svg>,
          closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
  <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676"/>
</svg>,
          duration: 3,
          top: 70,
        });
        setDatas(true);
        dispatch(
          shortcutKeyActions.updateValue({
            isUpdate: true,
          })
        );
      }
    });
  };

  const menu = (data: any) => (
    <ul className="keyEditlist">
      <li onClick={() => setOptions1(data)}>Edit command</li>
      <li onClick={() => setOptions2(data)}>Restore to default</li>
    </ul>
  );
  const Alphabets = /^[A-Za-z]+$/
  const changeVal = (e: any, data: any) => {
    if (Object.keys(data.keyValues).length === 3) {
      let validate = true
      if (customKeys.key2 !== "" && customKeys.key3 !== "") {
        if(!Alphabets.test(customKeys.key2) || !Alphabets.test(customKeys.key3)){
          return
        }
        keyData.map((dataz: any, index: any) => {
          if (dataz.keyValues.key1 === customKeys.key1 && dataz.keyValues.key2 === customKeys.key2 && dataz.keyValues.key3 === customKeys.key3) {
            setValidate(true);
            validate = false
          }
        });

        if (validate === true) {
          let body: any = {
            uuid: data.uuid,
            keyValues: {
              key1: customKeys.key1,
              key2: customKeys.key2,
              key3: customKeys.key3,
            },
            keyId: keyId,
          };
          CoreServices.put(body, `/update_shortcut_keys`).then((res: any) => {
            if (res && res.data.statusCode === 200) {
              setEditCommand(false);
              getInitialValue();
              notification.info({
                message: `${data.function} Updated Successfully `,
                placement: "topRight",
                className: "toastNotification success",
                icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000"/>
</svg>,
                closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
  <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676"/>
</svg>,
                duration: 3,
                top: 70,
              });
              setValidate(false);
              setDatas(true);
              dispatch(
                shortcutKeyActions.updateValue({
                  isUpdate: !shortcutKeysSlice.isUpdate,
                })
              );
            }
          });
        }
      }
    } else {
      let validate = true
      if(!customKeys.key2 || !Alphabets.test(customKeys.key2) ){
        return
      }
      keyData.map((dataz: any, index: any) => {
        if (dataz.keyValues.key1 === customKeys.key1 && dataz.keyValues.key2 === customKeys.key2) {
          setValidate(true);
          validate = false
        }
      });
      if (validate === true) {
        let body: any = {
          uuid: data.uuid,
          keyValues: {
            key1: customKeys.key1,
            key2: customKeys.key2,
          },
          keyId: keyId,
        };
        if (customKeys.key2 !== "") {
          CoreServices.put(body, `/update_shortcut_keys`).then((res: any) => {
            if (res && res.data.statusCode === 200) {
              setEditCommand(false);
              getInitialValue();
              notification.info({
                message: `${data.function} Updated  Successfully `,
                placement: "topRight",
                className: "toastNotification success",
                icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000"/>
</svg>,
                closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
  <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676"/>
</svg>,
                duration: 3,
                top: 70,
              });
              setDatas(true);
              dispatch(
                shortcutKeyActions.updateValue({
                  isUpdate: !shortcutKeysSlice.isUpdate,
                })
              );
            }
          });
        }
      }
    }
  };

  return (
    <>
      {loader.length < 1 ? (
        <Loader />
      ) : (
        <>
          <div className="noFluid">
            <Row>
              <Col span={24}>
                <Form form={form}>
                  <div>
                    <Row className="titleArea">
                      <Col sm={24}>
                        <h3>Shortcut Keys</h3>
                        <p>
                          To perform a specific task or execute a command quickly, instead of having to navigate through menus or use a mouse. These shortcuts will apply
                          when you are in active in the application
                        </p>
                      </Col>
                    </Row>
                    <div className={`boxWhite scroller  ${styles.shortcutpagescroller}`}>
                      <div className={styles.headingMD}>
                        <h4>Global Commands</h4>
                        <p>These Shortcuts Keys cannot be Edited</p>
                      </div>

                      <Row className={styles.shortcutbodysec}>
                        {defaultKeyData?.map((allData: any, index: any) => {
                            if (index === 0) return null; 
                          return (
                            <Fragment key={index}>
                              <Col span={24} md={10}>
                                {allData.function && (
                                  <>
                                    <div className={styles.keysRow}>
                                      <span className={styles.keyName}>{allData.function}</span>
                                      <span className={styles.keyBtn}>{allData.keyValues.key1}</span>
                                      <span className={styles.keyBtn}>{allData.keyValues.key2}</span>
                                      <span className={styles.onOffSts}>
                                        <Switch
                                          size="small"
                                          className="routingtableswitch"
                                          checked={allData.status === 1 ? true : false}
                                          onClick={(e: any) => setDefaultSwitchAction(e, allData)}
                                        />
                                      </span>
                                    </div>
                                  </>
                                )}
                              </Col>
                              <Col span={1}></Col>
                            </Fragment>
                          );
                        })}
                      </Row>

                      <hr className={`${styles.hrcode} customhrline  `}></hr> 
                      <div className={styles.headingMD}>
                        {/* <h4>These Shortcuts Keys cannot be Edited</h4> */}
                        <h4>Custom commands</h4>
                        <p>These Shortcuts Keys can be Edited</p>
                      </div>
                      <Row className={styles.shortcutbodysecond}>
                        {(PRIVILLEGED_ROLES.includes(roleId) || roleId == ROLES.SUPERVISOR_ROLE_ID) &&
                          keyData?.map((data: any, index: any) => {
                            return (
                              <Fragment key={index}>
                                <Col span={24} md={10}>
                                  <div className={`${styles.keysRow} keysrowfix`}>
                                    {Object.keys(data.keyValues).length === 3 && (
                                      <>
                                        <span className={styles.keyName}>{data.function}</span>
                                        {editCommand === true && editId === data.uuid && Object.keys(data.keyValues).length === 3 ? (
                                          <>
                                            <div className={`createcustomval ${styles.createcustomval}`}>
                                              <span className={styles.keyBtn}>{data.keyValues.key1}</span>
                                              <Form.Item
                                                className="sortinput"
                                                name="key1"
                                                initialValue={customKeys.key2 || null}
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: "Enter key",
                                                  },
                                                  {
                                                    pattern: /^[A-Za-z ]+$/gm,
                                                    message: "Only characters allowed",
                                                  },
                                                  {
                                                    async validator (_, value){
                                                      value = value?.toUpperCase()
                                                      for(let dataz of keyData){
                                                        if (dataz.keyValues.key1 === customKeys.key1 && dataz.keyValues.key2 === value && dataz.keyValues.key3 === customKeys.key3) {
                                                          return Promise.reject("Key combination already exists");
                                                         }
                                                      }
                                                      return Promise.resolve();
                                                    }
                                                  }
                                                ]}
                                              >
                                                <AntInput
                                                  // className={alert1 === true ? "activebdr" : ""}
                                                  maxLength={1}
                                                  placeHolder="A"
                                                  className={`keyinput1 ${styles.keyinput} ${styles.statusinput}`}
                                                  onBlur={(e: any) => changeVal(e, data)}
                                                  onChange={(e: any) => setCustomKeys({ ...customKeys, key1: data.keyValues.key1, key2: e.target.value.toUpperCase() })}
                                                ></AntInput>
                                              </Form.Item>

                                              <Form.Item
                                                className="sortinput"
                                                name="key3"
                                                initialValue={customKeys.key3 || null}
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: "Enter key",
                                                  },
                                                  {
                                                    pattern: /^[A-Za-z ]+$/gm,
                                                    message: "Only characters allowed",
                                                  },
                                                  {
                                                    async validator (_, value){
                                                      value = value?.toUpperCase()
                                                      for(let dataz of keyData){
                                                        if (dataz.keyValues.key1 === customKeys.key1 && dataz.keyValues.key2 === customKeys.key2 && dataz.keyValues.key3 === value) {
                                                          return Promise.reject("Key combination already exists");
                                                         }
                                                      }
                                                      return Promise.resolve();
                                                    }
                                                  }
                                                ]}
                                              >
                                                <AntInput
                                                  // className={alert2 === true ? "activebdr" : ""}
                                                  maxLength={1}
                                                  placeHolder="B"
                                                  className={`keyinput1 ${styles.keyinput} ${styles.statusinput}`}
                                                  onChange={(e: any) => setCustomKeys({ ...customKeys, key3: e.target.value.toUpperCase() })}
                                                  onBlur={(e: any) => changeVal(e, data)}
                                                ></AntInput>
                                              </Form.Item>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <span className={styles.keyBtn}>{data.keyValues.key1}</span>
                                            <span className={styles.keyBtn}>{data.keyValues.key2}</span>
                                            <span className={styles.keyBtn}>{data.keyValues.key3}</span>
                                          </>
                                        )}
                                        <span className={styles.onOffSts}>
                                          <Switch
                                            size="small"
                                            className="routingtableswitch"
                                            checked={data.status === 1 ? true : false}
                                            onClick={(e: any) => setSwitchAction(e, data)}
                                          />
                                        </span>
                                        <span className={styles.moreOption}>
                                          <Popover placement="bottomRight" content={menu(data)} trigger="click" overlayClassName="editshortcut">
                                            <span className={`icon__More36 ${styles.shortkeytool}`} />
                                          </Popover>
                                        </span>
                                      </>
                                    )}
                                    {Object.keys(data.keyValues).length === 2 && (
                                      <>
                                        <span className={styles.keyName}>{data.function}</span>
                                        {editCommand === true && editId === data.uuid && Object.keys(data.keyValues).length === 2 ? (
                                          <>
                                            <div className={`createcustomval ${styles.createcustomval}`}>
                                              <span className={styles.keyBtn}>{data.keyValues.key1}</span>
                                              <Form.Item
                                                className="sortinput"
                                                name="key2"
                                                initialValue={customKeys.key2 || null}
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: "Enter key",
                                                  },
                                                  {
                                                    pattern: /^[A-Za-z ]+$/gm,
                                                    message: "Only characters allowed",
                                                  },
                                                  {
                                                    async validator (_, value){
                                                      value = value?.toUpperCase()
                                                      for(let dataz of keyData){
                                                        if (dataz.keyValues.key1 === customKeys.key1 && dataz.keyValues.key2 === value) {
                                                          return Promise.reject("Key combination already exists");
                                                         }
                                                      }
                                                      return Promise.resolve();
                                                    }
                                                  }
                                                ]}
                                              >
                                                <AntInput
                                                  // className={alert1 === true ? "activebdr" : ""}
                                                  maxLength={1}
                                                  placeHolder="A"
                                                  className={`keyinput1 ${styles.keyinput} ${styles.statusinput}`}
                                                  onBlur={(e: any) => changeVal(e, data)}
                                                  onChange={(e: any) => setCustomKeys({ ...customKeys, key1: data.keyValues.key1, key2: e.target.value.toUpperCase() })}
                                                ></AntInput>
                                              </Form.Item>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <span className={styles.keyBtn}>{data.keyValues.key1}</span>
                                            <span className={`${styles.keyBtn} ${styles.keyBtn2}`}>{data.keyValues.key2}</span>
                                          </>
                                        )}
                                        <span className={styles.onOffSts}>
                                          <Switch
                                            size="small"
                                            className="routingtableswitch"
                                            checked={data.status === 1 ? true : false}
                                            onClick={(e: any) => setSwitchAction(e, data)}
                                          />
                                        </span>
                                        <span className={styles.moreOption}>
                                          <Popover placement="bottomRight" content={menu(data)} trigger="click" overlayClassName="editshortcut">
                                            <span className={`icon__More36 ${styles.shortkeytool}`} />
                                          </Popover>
                                        </span>
                                      </>
                                    )}
                                  </div>
                                </Col>
                                <Col span={1}></Col>
                              </Fragment>
                            );
                          })}

                        {roleId == ROLES.AGENT_ROLE_ID &&
                          keyData.map((data: any, index: any) => {
                            return (
                              <Fragment key={index}>
                                {(data.function === "My Activity tab" ||
                                  data.function === "Callback" ||
                                  data.function === "Leave Conference Call" ||
                                  data.function === "Bell Notification") && (
                                  <>
                                    <Col span={24} md={10}>
                                      <div className={styles.keysRow}>
                                        {Object.keys(data.keyValues).length === 3 && (
                                          <>
                                            <span className={styles.keyName}>{data.function}</span>
                                            {editCommand === true && editId === data.uuid && Object.keys(data.keyValues).length === 3 ? (
                                              <>
                                                <div className={`createcustomval ${styles.createcustomval}`}>
                                                  <span className={styles.keyBtn}>{data.keyValues.key1}</span>
                                                  <Form.Item
                                                    className="sortinput"
                                                    name="key2"
                                                    initialValue={customKeys.key2 || null}
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message: "Enter key",
                                                      },
                                                      {
                                                        pattern: /^[A-Za-z ]+$/gm,
                                                        message: "Only characters allowed",
                                                      },
                                                      {
                                                        async validator (_, value){
                                                          value = value?.toUpperCase()
                                                          for(let dataz of keyData){
                                                            if (dataz.keyValues.key1 === customKeys.key1 && dataz.keyValues.key2 === value && dataz.keyValues.key3 === customKeys.key3) {
                                                              return Promise.reject("Key combination already exists");
                                                             }
                                                          }
                                                          return Promise.resolve();
                                                        }
                                                      }
                                                    ]}
                                                  >
                                                    <AntInput
                                                      // className={alert1 === true ? "activebdr" : ""}
                                                      maxLength={1}
                                                      placeHolder="A"
                                                      className={`keyinput1 ${styles.keyinput} ${styles.statusinput}`}
                                                      onBlur={(e: any) => changeVal(e, data)}
                                                      onChange={(e: any) =>
                                                        setCustomKeys({ ...customKeys, key1: data.keyValues.key1, key2: e.target.value.toUpperCase() })
                                                      }
                                                    ></AntInput>
                                                  </Form.Item>

                                                  <Form.Item
                                                    className="sortinput"
                                                    name="key3"
                                                    initialValue={customKeys.key3 || null}
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message: "Enter key",
                                                      },
                                                      {
                                                        pattern: /^[A-Za-z ]+$/gm,
                                                        message: "Only characters allowed",
                                                      },
                                                      {
                                                        async validator (_, value){
                                                          value = value?.toUpperCase()
                                                          for(let dataz of keyData){
                                                            if (dataz.keyValues.key1 === customKeys.key1 && dataz.keyValues.key2 === customKeys.key2 && dataz.keyValues.key3 === value) {
                                                              return Promise.reject("Key combination already exists");
                                                             }
                                                          }
                                                          return Promise.resolve();
                                                        }
                                                      }
                                                    ]}
                                                  >
                                                    <AntInput
                                                      // className={alert2 === true ? "activebdr" : ""}
                                                      maxLength={1}
                                                      placeHolder="B"
                                                      className={`keyinput1 ${styles.keyinput} ${styles.statusinput}`}
                                                      onChange={(e: any) => setCustomKeys({ ...customKeys, key3: e.target.value.toUpperCase() })}
                                                      onBlur={(e: any) => changeVal(e, data)}
                                                    ></AntInput>
                                                  </Form.Item>
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                <span className={styles.keyBtn}>{data.keyValues.key1}</span>
                                                <span className={styles.keyBtn}>{data.keyValues.key2}</span>
                                                <span className={styles.keyBtn}>{data.keyValues.key3}</span>
                                              </>
                                            )}
                                            <span className={styles.onOffSts}>
                                              <Switch
                                                size="small"
                                                className="routingtableswitch"
                                                checked={data.status === 1 ? true : false}
                                                onClick={(e: any) => setSwitchAction(e, data)}
                                              />
                                            </span>
                                            <span className={styles.moreOption}>
                                              <Popover placement="bottomRight" content={menu(data)} trigger="click" overlayClassName="editshortcut">
                                                <span className={`icon__More36 ${styles.shortkeytool}`} />
                                              </Popover>
                                            </span>
                                          </>
                                        )}
                                        {Object.keys(data.keyValues).length === 2 && (
                                          <>
                                            <span className={styles.keyName}>{data.function}</span>
                                            {editCommand === true && editId === data.uuid && Object.keys(data.keyValues).length === 2 ? (
                                              <>
                                                <div className={`createcustomval ${styles.createcustomval}`}>
                                                  <span className={styles.keyBtn}>{data.keyValues.key1}</span>
                                                  <Form.Item
                                                    className="sortinput"
                                                    initialValue={customKeys.key2 || null}
                                                    name="key2"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message: "Enter key",
                                                      },
                                                      {
                                                        pattern: /^[A-Za-z ]+$/gm,
                                                        message: "Only characters allowed",
                                                      },
                                                      {
                                                        validator: (_, value) => {
                                                          keyData.map((dataz: any, index: any) => {
                                                            if (dataz.keyValues.key1 === customKeys.key1 && dataz.keyValues.key2 === value ) {
                                                              return Promise.reject(new Error("Key combination already exists"));
                                                             }
                                                          });
                                                          return Promise.resolve();
                                                        }
                                                      }
                                                    ]}
                                                  >
                                                    <AntInput
                                                      // className={alert1 === true ? "activebdr" : ""}
                                                      maxLength={1}
                                                      placeHolder="A"
                                                      className={`keyinput1 ${styles.keyinput} ${styles.statusinput}`}
                                                      onBlur={(e: any) => changeVal(e, data)}
                                                      onChange={(e: any) =>
                                                        setCustomKeys({ ...customKeys, key1: data.keyValues.key1, key2: e.target.value.toUpperCase() })
                                                      }
                                                    ></AntInput>
                                                  </Form.Item>
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                <span className={styles.keyBtn}>{data.keyValues.key1}</span>
                                                <span className={`${styles.keyBtn} ${styles.keyBtn2}`}>{data.keyValues.key2}</span>
                                              </>
                                            )}
                                            <span className={styles.onOffSts}>
                                              <Switch
                                                size="small"
                                                className="routingtableswitch"
                                                checked={data.status === 1 ? true : false}
                                                onClick={(e: any) => setSwitchAction(e, data)}
                                              />
                                            </span>
                                            <span className={styles.moreOption}>
                                              <Popover placement="bottomRight" content={menu(data)} trigger="click" overlayClassName="editshortcut">
                                                <span className={`icon__More36 ${styles.shortkeytool}`} />
                                              </Popover>
                                            </span>
                                          </>
                                        )}
                                      </div>
                                    </Col>
                                    <Col span={1}></Col>
                                  </>
                                )}
                              </Fragment>
                            );
                          })}

                        <ShortCutKeys data={datas} />
                      </Row>
                    </div>
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
        </>
      )}
    </>
  );
}
export { ShortcutKeys };
